module.exports = __webpack_public_path__ + "coin_TRX.png?f6d12061229b4b16a1c0c3fe3336004f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_TRX.png
// module id = 1119
// module chunks = 2